"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLECTIONS_WITH_CHANGE_HISTORY = exports.CollectionNameEnum = void 0;
var CollectionNameEnum;
(function (CollectionNameEnum) {
    CollectionNameEnum["COST_CENTER"] = "CostCenter";
    CollectionNameEnum["COST_CENTER_2"] = "CostCenter2";
    CollectionNameEnum["VENDOR"] = "Vendor";
    CollectionNameEnum["EXPENSE"] = "Expense";
    CollectionNameEnum["EXPENSE_ACCOUNT"] = "ExpenseAccount";
    CollectionNameEnum["USER"] = "User";
    CollectionNameEnum["BANK_CONNECTION"] = "BankConnection";
    CollectionNameEnum["PAYMENT_SETTINGS"] = "PaymentSettings";
    CollectionNameEnum["PAYMENT_INVOICE"] = "PaymentInvoice";
    CollectionNameEnum["PAYMENT_PRODUCT"] = "PaymentProduct";
    CollectionNameEnum["COMPANY_SETTINGS"] = "CompanySettings";
    CollectionNameEnum["ACTIVITY"] = "Activity";
    CollectionNameEnum["CURRENCY_EXCHANGE"] = "CurrencyExchange";
    CollectionNameEnum["MATCHING_TRANSACTION"] = "MatchingTransaction";
    CollectionNameEnum["BUSINESS_DATA"] = "BusinessData";
    CollectionNameEnum["CARD"] = "Card";
    CollectionNameEnum["WALLET"] = "Wallet";
    CollectionNameEnum["INBOX_INVOICE"] = "InboxInvoice";
    CollectionNameEnum["CORPORATE"] = "Corporate";
    CollectionNameEnum["TEAM"] = "Team";
    CollectionNameEnum["TAX"] = "Tax";
    CollectionNameEnum["WORKFLOW"] = "Workflow";
    CollectionNameEnum["IMPORT_RESULT"] = "ImportResult";
    CollectionNameEnum["TENANT"] = "Tenant";
    CollectionNameEnum["TRANSACTION_CATEGORY"] = "TransactionCategory";
    CollectionNameEnum["EXPENSE_TAG"] = "ExpenseTag";
    CollectionNameEnum["CSV_TEMPLATE"] = "CsvTemplate";
    CollectionNameEnum["ACCOUNT_STATEMENT"] = "AccountStatement";
    CollectionNameEnum["MAIL_QUEUE"] = "MailQueue";
    CollectionNameEnum["MAIL_HISTORY"] = "MailHistory";
    CollectionNameEnum["FILTER"] = "Filter";
    CollectionNameEnum["PER_DIEM_DESTINATION"] = "PerDiemDestination";
    CollectionNameEnum["LIQUIDITY_SCENARIO"] = "LiquidityScenario";
    CollectionNameEnum["LIQUIDITY_FORECAST_RULE"] = "LiquidityForecastRule";
    CollectionNameEnum["ROLE"] = "Role";
    CollectionNameEnum["EXPORT_HISTORY"] = "ExportHistory";
    CollectionNameEnum["IDP"] = "IDP";
    CollectionNameEnum["SSO"] = "SSO";
    CollectionNameEnum["DATEV_ONLINE_JOB"] = "DatevOnlineJob";
    CollectionNameEnum["SUBSCRIPTION"] = "Subscription";
    CollectionNameEnum["QUEUE_MESSAGE"] = "QueueMessage";
    CollectionNameEnum["EMAIL_FORWARDING_EVENT"] = "EmailForwardingEvent";
    CollectionNameEnum["FILE"] = "File";
    CollectionNameEnum["INVOICE_FILE"] = "InvoiceFile";
    CollectionNameEnum["PURCHASE_ORDER"] = "PurchaseOrder";
    CollectionNameEnum["DELIVERY_NOTE"] = "DeliveryNote";
})(CollectionNameEnum || (exports.CollectionNameEnum = CollectionNameEnum = {}));
exports.COLLECTIONS_WITH_CHANGE_HISTORY = [
    CollectionNameEnum.EXPENSE,
    CollectionNameEnum.USER,
    CollectionNameEnum.MATCHING_TRANSACTION,
    CollectionNameEnum.COMPANY_SETTINGS,
    CollectionNameEnum.VENDOR,
    CollectionNameEnum.ROLE,
    CollectionNameEnum.WALLET,
    CollectionNameEnum.BANK_CONNECTION,
    CollectionNameEnum.COST_CENTER_2,
    CollectionNameEnum.CARD,
    CollectionNameEnum.CORPORATE,
    CollectionNameEnum.COST_CENTER,
    CollectionNameEnum.EXPENSE_TAG,
    CollectionNameEnum.INBOX_INVOICE,
    CollectionNameEnum.TAX,
    CollectionNameEnum.TEAM,
    CollectionNameEnum.WORKFLOW,
    CollectionNameEnum.CSV_TEMPLATE,
    CollectionNameEnum.EXPENSE_ACCOUNT,
    CollectionNameEnum.PURCHASE_ORDER,
    CollectionNameEnum.DELIVERY_NOTE,
];
